import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="Home">
      <div className="terms" id="PrivacyPolicy">
        <h2>شروط الاشتراك بغرف دردشة لايك جي شات أو أي خدمات أخرى</h2>

        <div className="room-laws">
          <h4>
            • عند اشتراكك في أحد خدمات دردشة لايك جي شات فإنك تعتبر موافقاً
            موافقة تامة على الالتزام بجميع الشروط والقوانين المسجلة التالية وعدم
            الالتزام بها يؤدي لإلغاء اشتراكك دون أي تعويض.
          </h4>

          <div className="laws">
            <h4>
              • الأسعار بالموقع تعتبر ثابتة ولا يمكن تخفيضها إلا في أوقات العروض
              الخاصة.
            </h4>
            <h4>
              • التحدث المباشر يعتبر للمبيعات بالدرجة الأولى، ويحق للموظف الطلب
              من العميل أن يقوم بإرسال بريد الكتروني أو التواصل عبر رقم الهاتف
              الخاص بالمبيعات بدلاً من التحدث إليه مباشرة.
            </h4>
            <h4>
              • في حال مخالفة الشروط قد يفرض موقع لايك جي شات غرامة لإعادة
              الخدمة تقوم بتقديرها ويحق لها تحديد السعر دون وضعه في الشروط أو قد
              تقوم بإلغاء الاشتراك ولا يحق لك المطالبة بأي تعويض.
            </h4>
            <h4>
              • لا نقدم أي خدمة أو دعمها إلا لصاحب الاشتراك وبياناته المسجلة
              لدينا فقط، وموقع لايك جي شات يمكنه تزويد بيانات المشترك لأي جهة
              رسمية عند الطلب.
            </h4>
            <h4>
              • شروط الاشتراك في الخدمات: مخالفتك لأي من هذه الشروط يؤدي لإلغاء
              اشتراكك بشكل كامل بدون أي تعويض.
            </h4>
            <h4>
              • كل المواضيع المطروحة في الغرفة صوت أو صورة أو فيديو يعتبر مسؤول
              عنها بشكل كامل مالك الغرفة.
            </h4>
            <h4>• عدم طرح المواضيع السياسية والدينية الطائفية.</h4>
            <h4>• عدم إعطاء كلمة مرور حساب master الرئيسي لأي شخص كان.</h4>
            <h4>• فقدانك لكود الماستر الرئيسي يعني إلغاء اشتراكك.</h4>
            <h4>
              • إعطاء أسماء الشرافات أو أسماء روت بكامل الصلاحيات لأشخاص غير
              معروفين يؤدي لتخريب غرفتك وقد يؤدي لإلغاء اشتراكك أو فرض رسوم
              إضافية لإعادة التفعيل.
            </h4>
            <h4>
              • يمنع وضع الإعلانات داخل الغرفة (مثل مواقع أو روابط أخرى) أو
              إيميلات أو أرقام هاتف أو صور شخصية للغير.
            </h4>
            <h4>
              • يمنع بيع أو شراء أي غرفة أو أي خدمة أخرى خارج غرفة المبيعات من
              قبل أي عميل، فنحن غير مسؤولين عن أي عملية نصب أو احتيال تحصل خارج
              غرفة المبيعات الخاصة بموقع لايك جي شات.
            </h4>
            <h4>
              • يمنع بشكل كامل استغلال غرفة الدردشة للأمور التجارية مهما كان
              نوعها، والطرف الوحيد المسؤول عن المبيعات هو غرفة المبيعات التابعة
              لموقع لايك جي شات.
            </h4>
            <h4>
              • يمنع وضع روابط لمواقع إباحية أو روابط لصفحات فيها فضائح أو
              انتهاك خصوصية وما شابه.
            </h4>
            <h4>
              • يمنع استغلال الملف الشخصي أو الاسم المحمي بوضع إعلانات لمواقع
              أخرى أو عبارات غير لائقة وغير مناسبة.
            </h4>
            <h4>
              • لا يمكنك استعادة كلمة مرور الاسم المحمي إذا كان مسجل بنفس رقم
              الهاتف المعتمد أكثر من اسم، حفاظاً على خصوصية المستخدم.
            </h4>
            <h4>
              • يمنع تشغيل برنامج الكاميرا للعرض الإباحي أو الإعلاني داخل غرفتك،
              ويحق لأي شخص التبليغ عن أي استخدام مخالف لنظام الكاميرا، مما يؤدي
              لحظر المرسل وإلغاء اشتراكك نهائياً.
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
